import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Search, PlusCircle, Heart, User } from 'lucide-react';

// Memoize the BottomNav component to prevent unnecessary re-renders
export const BottomNav = memo(() => {
  return (
    <nav className="bottom-nav will-change-transform">
      <div className="grid grid-cols-5 gap-1">
        <NavLink
          to="/home"
          className={({ isActive }) =>
            `nav-link ${isActive ? 'active' : ''}`
          }
        >
          <div className="nav-icon-container">
            <Home strokeWidth={1.5} size={24} />
          </div>
          <span className="text-xs font-medium">Home</span>
        </NavLink>
        
        <NavLink
          to="/search"
          className={({ isActive }) =>
            `nav-link ${isActive ? 'active' : ''}`
          }
        >
          <div className="nav-icon-container">
            <Search strokeWidth={1.5} size={24} />
          </div>
          <span className="text-xs font-medium">Search</span>
        </NavLink>
        
        <NavLink
          to="/submit"
          className={({ isActive }) =>
            `nav-link ${isActive ? 'active' : ''}`
          }
        >
          <div className="nav-icon-container bg-primary-500 text-white">
            <PlusCircle strokeWidth={1.5} size={26} />
          </div>
          <span className="text-xs font-medium">Submit</span>
        </NavLink>
        
        <NavLink
          to="/favorites"
          className={({ isActive }) =>
            `nav-link ${isActive ? 'active' : ''}`
          }
        >
          <div className="nav-icon-container">
            <Heart strokeWidth={1.5} size={24} />
          </div>
          <span className="text-xs font-medium">Favorites</span>
        </NavLink>
        
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `nav-link ${isActive ? 'active' : ''}`
          }
        >
          <div className="nav-icon-container">
            <User strokeWidth={1.5} size={24} />
          </div>
          <span className="text-xs font-medium">Profile</span>
        </NavLink>
      </div>
    </nav>
  );
});

BottomNav.displayName = 'BottomNav';